
import React, { useState } from 'react';
import DeviceStatusChart from './charts/DeviceStatusChart';
import SmartMeterPerformanceChart from './charts/SmartMeterPerformanceChart';
import GatewayPerformanceChart from './charts/GatewayPerformanceChart';

interface DeviceSummaryChartsProps {
  chartData: any[];
  telemetryType: 'energy' | 'gas' | 'water';
  deviceType: 'smartMeters' | 'gateways';
}

const DeviceSummaryCharts: React.FC<DeviceSummaryChartsProps> = ({
  chartData,
  telemetryType,
  deviceType
}) => {
  // State to track which lines are visible for each chart
  const [hiddenStatusLines, setHiddenStatusLines] = useState<string[]>([]);
  const [hiddenPerformanceLines, setHiddenPerformanceLines] = useState<string[]>([]);

  // Toggle visibility of a line when legend is clicked
  const handleStatusLegendClick = (dataKey: string) => {
    setHiddenStatusLines(prevHiddenLines => 
      prevHiddenLines.includes(dataKey)
        ? prevHiddenLines.filter(key => key !== dataKey)
        : [...prevHiddenLines, dataKey]
    );
  };

  const handlePerformanceLegendClick = (dataKey: string) => {
    setHiddenPerformanceLines(prevHiddenLines => 
      prevHiddenLines.includes(dataKey)
        ? prevHiddenLines.filter(key => key !== dataKey)
        : [...prevHiddenLines, dataKey]
    );
  };

  return (
    <div className="grid grid-cols-1 gap-6 mt-6">
      {/* Status Chart */}
      <DeviceStatusChart 
        chartData={chartData}
        hiddenLines={hiddenStatusLines}
        onLegendClick={handleStatusLegendClick}
        deviceType={deviceType}
      />
      
      {/* Performance Chart - conditionally render based on device type */}
      {deviceType === 'smartMeters' ? (
        <SmartMeterPerformanceChart 
          chartData={chartData}
          hiddenLines={hiddenPerformanceLines}
          onLegendClick={handlePerformanceLegendClick}
          telemetryType={telemetryType}
        />
      ) : (
        <GatewayPerformanceChart 
          chartData={chartData}
          hiddenLines={hiddenPerformanceLines}
          onLegendClick={handlePerformanceLegendClick}
        />
      )}
    </div>
  );
};

export default DeviceSummaryCharts;
